/**
 * Generic constructor type
 */
export type Constructor<T = {}> = new (...args: any[]) => T;
